import { NotebookStore } from "@store";
import { NextRouter } from "next/router";
import React, { useContext } from "react";
import { IBlock, IInternalLink, isBlock, isInternalLink } from "./types";

type ClickEvent = React.MouseEvent<Element, MouseEvent>;

export interface Interaction {
  onClickInternalLink: (event: ClickEvent, element: IInternalLink | IBlock) => void;
}

const InteractionContext = React.createContext<Interaction | null>(null);

export const InteractionProvider = InteractionContext.Provider;

export const useInteraction = (): Interaction => {
  const x = useContext(InteractionContext);

  if (!x) {
    throw new Error("invalid provider");
  }

  return x;
};

export class BasicInteraction implements Interaction {
  private readonly router: NextRouter;
  private readonly notebook: NotebookStore;

  constructor(router: NextRouter, notebook: NotebookStore) {
    this.router = router;
    this.notebook = notebook;
  }

  public onClickInternalLink(event: ClickEvent, element: IInternalLink | IBlock) {
    event.preventDefault();

    if (isInternalLink(element)) {
      const url = this.notebook.resolve(element.target);
      if (url) {
        this.router.push(url);
      }
    }
    else if (isBlock(element)) {
      const url = this.notebook.resolve(element.subject);
      if (url) {
        this.router.push(url);
      }
    }
  }
}
